export interface AiActionTypeMeta {
  code: string
  title: string
  color: string
  description: string
}

export const AI_ACTION_TYPES: Record<string, AiActionTypeMeta> = {
  evaluate_sentence: {
    code: "evaluate_sentence",
    title: "Luyện đặt câu & Chấm điểm",
    color: "blue",
    description: "Chấm điểm câu người dùng tự đặt trong từ điển",
  },
  ai_add_chat: {
    code: "ai_add_chat",
    title: "Thêm từ AI - Chat / Prompt",
    color: "purple",
    description: "Tạo từ vựng theo chủ đề/yêu cầu người dùng",
  },
  ai_add_extract_text: {
    code: "ai_add_extract_text",
    title: "Thêm từ AI - Trích xuất văn bản",
    color: "green",
    description: "Lọc và trích xuất từ vựng từ đoạn văn bản",
  },
  ai_add_extract_image: {
    code: "ai_add_extract_image",
    title: "Thêm từ AI - Trích xuất hình ảnh (OCR)",
    color: "orange",
    description: "Quét ảnh bài học/sách để lấy từ vựng",
  },
  quick_add_fallback_generate: {
    code: "quick_add_fallback_generate",
    title: "Thêm nhanh - Tự động sinh nghĩa từ lạ",
    color: "gold",
    description: "Tự động sinh nghĩa/ví dụ cho từ không có trong từ điển",
  },
  meaning_embedding_match: {
    code: "meaning_embedding_match",
    title: "Khớp nghĩa từ vựng (Embedding)",
    color: "default",
    description: "Thuật toán vector khớp nghĩa người dùng nhập",
  },
}

export const getAiActionTypeInfo = (actionType: string): AiActionTypeMeta => {
  return (
    AI_ACTION_TYPES[actionType] || {
      code: actionType,
      title: actionType,
      color: "default",
      description: actionType,
    }
  )
}

export const USD_TO_VND_RATE = 26000

export const formatUsdAndVnd = (costUsd?: number | string | null) => {
  const numCost = Number(costUsd || 0)
  if (numCost <= 0) return { usd: "$0.00", vnd: "0 đ", fullText: "$0.00 (0 đ)" }

  const formattedUsd =
    numCost < 0.01 ? `$${numCost.toFixed(6)}` : `$${numCost.toLocaleString("en-US", { minimumFractionDigits: 4, maximumFractionDigits: 4 })}`
  const vndAmount = Math.round(numCost * USD_TO_VND_RATE)
  const formattedVnd = `${vndAmount.toLocaleString("vi-VN")} đ`

  return {
    usd: formattedUsd,
    vnd: formattedVnd,
    fullText: `${formattedUsd} (≈ ${formattedVnd})`,
  }
}
